import React from 'react';
import Icon from '../../../components/AppIcon';

const MissionSection = ({ language }) => {
  const content = {
    en: {
      title: "Our Mission",
      description: "WGIH is dedicated to bridging the gap between Africa's exceptional coffee producers and discerning Chinese buyers. We specialize in sourcing premium green coffee beans directly from verified farms across Ethiopia, Nigeria, Uganda, and Kenya.\n\nOur commitment extends beyond simple trading - we ensure complete transparency through geospatial farm data, comprehensive quality testing, and rigorous supplier verification. Every bean we import tells a story of sustainable farming practices and exceptional quality standards.",
      values: [
        {
          icon: "Shield",
          title: "Quality Assurance",
          description: "Rigorous testing and certification for every batch"
        },
        {
          icon: "Globe",
          title: "Direct Sourcing",
          description: "Direct relationships with verified African farms"
        },
        {
          icon: "Award",
          title: "Transparency",
          description: "Complete traceability with geospatial farm data"
        },
        {
          icon: "Users",
          title: "Partnership",
          description: "Long-term relationships built on trust and quality"
        }
      ]
    },
    zh: {
      title: "我们的使命",
      description: "WGIH致力于连接非洲优秀的咖啡生产商与挑剔的中国买家。我们专注于直接从埃塞俄比亚、尼日利亚、乌干达和肯尼亚的认证农场采购优质生咖啡豆。\n\n我们的承诺不仅仅是简单的贸易 - 我们通过地理空间农场数据、全面的质量测试和严格的供应商验证确保完全透明。我们进口的每一颗咖啡豆都讲述着可持续农业实践和卓越质量标准的故事。",
      values: [
        {
          icon: "Shield",
          title: "质量保证",
          description: "每批次严格测试和认证"
        },
        {
          icon: "Globe",
          title: "直接采购",
          description: "与经过验证的非洲农场直接合作"
        },
        {
          icon: "Award",
          title: "透明度",
          description: "通过地理空间农场数据实现完全可追溯性"
        },
        {
          icon: "Users",
          title: "合作伙伴关系",
          description: "建立在信任和质量基础上的长期关系"
        }
      ]
    }
  };

  return (
    <section className="py-12 md:py-16 lg:py-20 px-4 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground mb-6">
            {content?.[language]?.title}
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-4xl mx-auto whitespace-pre-line leading-relaxed">
            {content?.[language]?.description}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {content?.[language]?.values?.map((value, index) => (
            <div
              key={index}
              className="bg-card border border-border rounded-lg p-6 text-center hover:shadow-lg transition-smooth"
            >
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name={value?.icon} size={32} color="var(--color-primary)" />
              </div>
              <h3 className="text-xl font-heading font-semibold text-foreground mb-3">
                {value?.title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {value?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MissionSection;